import {
  SeasonEligibility,
  So5LeaderboardSeasonality,
} from '@sorare/core/src/__generated__/globalTypes';
import { seasonEligibilityMessages } from '@sorare/core/src/lib/glossary';

export const ALL_VALUE = 'ALL';
type AllValue = typeof ALL_VALUE;

export type SeasonEligibilityOptions =
  | SeasonEligibility
  | AllValue
  | So5LeaderboardSeasonality;

export const seasonEligibilityOptionsMessages = {
  ...seasonEligibilityMessages,
  [So5LeaderboardSeasonality.ALL_SEASONS]: seasonEligibilityMessages.CLASSIC,
};

export const seasonEligibilityOptions: SeasonEligibilityOptions[] = [
  SeasonEligibility.IN_SEASON,
  SeasonEligibility.CLASSIC,
  ALL_VALUE,
];
